module.exports = (__webpack_require__(2))(71);


//////////////////
// WEBPACK FOOTER
// delegated ./src/constants.js from dll-reference girder_plugin_slicer_cli_web
// module id = 20
// module chunks = 0